"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRefreshManager = exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType[TokenType["Anonymous"] = 0] = "Anonymous";
    TokenType[TokenType["Host"] = 1] = "Host";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var TokenRefreshManager = /** @class */ (function () {
    function TokenRefreshManager() {
        this.timers = new Map();
    }
    /**
     * Schedules refresh of token with provided id and relative token expiration time, using provided fetch operation
     */
    TokenRefreshManager.prototype.scheduleRefresh = function (tokenType, tokenExpiresInSec, fetchOperation) {
        var timer = this.timers.get(tokenType);
        if (!timer) {
            timer = { numberOfAttempts: 0 };
            this.timers.set(tokenType, timer);
        }
        if (timer.timeoutId) {
            clearTimeout(timer.timeoutId);
            timer.timeoutId = undefined;
        }
        var tokenExpirationOffset = tokenExpiresInSec * 1000 - TokenRefreshManager.tokenExpirationBufferMs;
        if (tokenExpirationOffset > 0) {
            timer.numberOfAttempts = 0;
        }
        else {
            // Offset being negative means that token is not longer valid and that we should schedule a refresh
            // We will increment number of attempts and adjust offset so that we do not attempt refresh more than once per tokenRefreshBackoffIntervalMs
            ++timer.numberOfAttempts;
            tokenExpirationOffset = TokenRefreshManager.tokenRefreshBackoffIntervalMs;
        }
        if (timer.numberOfAttempts <= TokenRefreshManager.tokenRefreshMaximumAttempts) {
            timer.timeoutId = setTimeout(function () { return fetchOperation(); }, tokenExpirationOffset);
        }
    };
    TokenRefreshManager.prototype.clearTimeouts = function () {
        this.timers.forEach(function (timer) {
            clearTimeout(timer.timeoutId);
        });
        this.timers = new Map();
    };
    TokenRefreshManager.tokenExpirationBufferMs = 1000 * 60 * 4; // 4 minutes
    TokenRefreshManager.tokenRefreshBackoffIntervalMs = 30000; // 30 seconds;
    TokenRefreshManager.tokenRefreshMaximumAttempts = 3;
    return TokenRefreshManager;
}());
exports.TokenRefreshManager = TokenRefreshManager;
//# sourceMappingURL=token-refresh-manager.js.map